import { render, staticRenderFns } from "./gerar-receita-xml.vue?vue&type=template&id=3ec5b698&"
import script from "./gerar-receita-xml.vue?vue&type=script&lang=js&"
export * from "./gerar-receita-xml.vue?vue&type=script&lang=js&"
import style0 from "./gerar-receita-xml.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports